<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" md="3" class="d-none d-md-flex">
                <TableCategory />
            </v-col>
            <v-col cols="12" md="9">
                <div class="title mb-1">
                    <span class="text-h4">Promo</span>
                </div>
                <v-row>
                    <v-col cols="6" md="3" v-for="(value, index) in promo" v-bind:key="index">
                        <v-card class="card-category">
                            <router-link :to="{ name: 'Promo Detail', params: { id: value.id }}">
                                <v-img aspect-ratio="1" :src="value.image"></v-img>
                            </router-link>
                            <v-card-text class="pa-2">
                                <router-link :to="{ name: 'Promo Detail', params: { id: value.id }}">
                                    <div class="font-weight-bold text-h6">{{value.name}}</div>
                                    <div>{{value.discount}}</div>
                                </router-link>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <div class="text-center pa-4" v-if="page.total > 1">
                    <v-pagination
                        v-model="page.current"
                        :length="page.total"
                        :total-visible="9"
                        @input="getData"
                        prev-icon="fas fa-angle-left small"
                        next-icon="fas fa-angle-right small"
                    ></v-pagination>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import TableCategory from '@/components/TableCategory.vue';
    export default {
        props: ['id'],
        components: {
            TableCategory
        },
        data: () => ({
            promo: [],
            page: {
                current: 1,
                total: 0
            }
        }),
        mounted() {
            this.getData(1);
        },
        watch: { 
            id: function() {
                this.getData(1);
            }
        },
        methods: {
            getData(page) {
                this.$store.dispatch('requestAPI', {
                    name: 'promo/lists',
                    params: {
                        'page': page
                    }
                }).then(async response => {
                    this.page.current = parseInt(response.data.result.page);
                    this.page.total = parseInt(response.data.result.pageTotal);
                    this.promo = response.data.result.data;
                });
            }
        },
    }
</script>